const initialState = false;

export default (state = initialState, action) => {
    switch (action.type) {
        case "UPDATE_IS_COMMERCIAL_VESSEL_TYPE":
            return action.data;
          
        default:
            return state;
    }
}
